import styled from 'styled-components';

export const AfterSaleCreateFormFlowStyles = styled.div``;

export const AfterSaleCreateFormStyles = styled.div`
   width: 80%;
  margin: 0 auto;

 

  .form-container-after-sale {
  margin: auto;
  width: 100%;
  max-width: 600px;
  padding-top: 15px;
}

@media (min-width: 300px) and (max-width: 1000px) {
      width: 100%;
  }
  @media (min-width: 1001px) and (max-width: 1300px) {
      width: 80%;
  }


`;

export const AfterSalePurchaseStyles = styled.div`
  position: relative;
  /* CSS */
  .steps {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1rem;
    position: relative;
  }

  .step-button {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    border: none;
    background-color: var(--prm-gray);
    transition: 0.4s;
  }

  .step-button[aria-expanded="true"] {
    width: 60px;
    height: 60px;
    background-color: var(--greenia-color);
    color: #fff;
  }

  .done {
    background-color: var(--greenia-color);
    color: #fff;
  }

  .step-item {
    z-index: 10;
    text-align: center;
  }

  #progress {
    -webkit-appearance: none;
    position: absolute;
    width: 98%;
    z-index: 5;
    height: 10px;
    margin-left: 5px;
  }

  @media only screen and (max-width: 500px) {
    .steps {
      margin-bottom: 20px;
    }

    .step-item {
      font-size: 10px;
    }

    .step-button {
      height: 35px;
      width: 35px;
    }

    .step-button[aria-expanded="true"] {
      width: 50px;
      height: 50px;
      background-color: var(--greenia-color);
      color: #fff;
    }

    .step-title {
      font-size: 10px;
      text-align: center;
      flex: 1;
      margin-top: 5px;
    }
  }

  /*@media only screen and (max-width: )*/

  /* to customize progress bar */
  #progress::-webkit-progress-value {
    background-color: var(--greenia-color);
    transition: 0.5s ease;
  }

  #progress::-webkit-progress-bar {
    background-color: var(--prm-gray);
  }

  .support-box {
    max-width: 100px;
    width: 50px;
    max-height: 100px;
    height: 50px;
  }

  .row-flex {
    display: flex;
    flex-wrap: wrap;
  }

  .content {
    height: 100%;
    padding: 20px 20px 10px;
    color: #fff;
  }

  .doc-btn {
    margin: 0 5px;
    transition: all 250ms ease-in-out;
  }

  .doc-btn:hover {
    transform: scale(1.03);
  }

  .bg-secondary,
  .bg-primary {
    background-color: #00a651 !important;
  }

  .btn-outline-primary {
    --bs-btn-color: var(--greenia-color);
    --bs-btn-border-color: var(--greenia-color);
    --bs-btn-hover-color: #fff;
    --bs-btn-hover-bg: var(--greenia-color);
    --bs-btn-hover-border-color: var(--greenia-color);
    --bs-btn-focus-shadow-rgb: 13, 110, 253;
    --bs-btn-active-color: #fff;
    --bs-btn-active-bg: var(--greenia-color);
    --bs-btn-active-border-color: var(--greenia-color);
    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
    --bs-btn-disabled-color: var(--greenia-color);
    --bs-btn-disabled-bg: transparent;
    --bs-btn-disabled-border-color: var(--greenia-color);
    --bs-gradient: none;
  }

  .btn-outline-primary:focus {
    box-shadow: 0 0 0 0.25rem rgba(0, 166, 81, 0.5);
  }

  /* New Input Added */

  .upload_dropZone {
    color: #0f3c4b;
    background-color: var(--colorPrimaryPale, #c8dadf);
    outline: 2px dashed var(--colorPrimaryHalf, #c1ddef);
    outline-offset: -12px;
    transition: outline-offset 0.2s ease-out, outline-color 0.3s ease-in-out,
      background-color 0.2s ease-out;
  }
  .upload_dropZone.highlight {
    outline-offset: -4px;
    outline-color: var(--colorPrimaryNormal, #0576bd);
    background-color: var(--colorPrimaryEighth, #c8dadf);
  }
  .upload_svg {
    fill: var(--colorPrimaryNormal, #0576bd);
  }
  .btn-upload {
    color: #fff;
    background-color: var(--colorPrimaryNormal);
  }
  .btn-upload:hover,
  .btn-upload:focus {
    color: #fff;
    background-color: var(--colorPrimaryGlare);
  }
  .upload_img {
    width: calc(33.333% - (2rem / 3));
    object-fit: contain;
  }

  #back-button {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 40px;
    width: 40px;
    color: var(--greenia-color);
    font-size: 20px;
    border: 1px solid var(--greenia-color);
    border-radius: 100%;
    cursor: pointer;
  }

  .alert.alert-info {
    border-color: #00a651;
    background-color: #00c05d;
    color: white;
  }
`;

export const OfferCard = styled.div`
  background: ${(props) => props.bg || '#fff'};
  border-radius: 20px;
  border: 2px solid ${(props) => props.borderColor || '#dbdde6'};
  padding: 2rem;
`;

export const OfferIconBadge = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: ${(props) => props.bg || 'var(--greenia-color)'};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;
  color: #fff;
  font-size: 1.5rem;
`;

export const OfferAmountBox = styled.div`
  background: #fff;
  border-radius: 15px;
  padding: 1.5rem;
  border: 2px dashed ${(props) => props.borderColor || 'var(--greenia-color)'};
  max-width: ${(props) => props.maxWidth || 'none'};
  margin-left: auto;
  margin-right: auto;
`;

export const OfferAmountLabel = styled.p`
  color: #666;
  margin-bottom: 0.25rem;
  font-size: 0.85rem;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
`;

export const OfferAmountValue = styled.p`
  font-size: ${(props) => props.fontSize || '2.2rem'};
  font-weight: 800;
  color: ${(props) => props.color || '#333'};
  margin-bottom: 0;
  text-decoration: ${(props) => (props.strikethrough ? 'line-through' : 'none')};
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
`;

export const OfferAcceptButton = styled.button`
  padding: 12px 32px;
  border-radius: 15px;
  border: 2px solid var(--greenia-color);
  background: var(--greenia-color);
  color: #fff;
  font-weight: 600;
  font-size: 1rem;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  transition: all 250ms linear;
  opacity: ${(props) => (props.disabled ? 0.7 : 1)};
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};

  &:hover:not(:disabled) {
    background: transparent;
    color: var(--greenia-color);
  }
`;

export const OfferRejectButton = styled.button`
  padding: 12px 32px;
  border-radius: 15px;
  border: 2px solid #dc3545;
  background: transparent;
  color: #dc3545;
  font-weight: 600;
  font-size: 1rem;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  transition: all 250ms linear;
  opacity: ${(props) => (props.disabled ? 0.7 : 1)};
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};

  &:hover:not(:disabled) {
    background: #dc3545;
    color: #fff;
  }
`;

export const OfferStatusBadge = styled.div`
  background: ${(props) => props.bg || 'rgba(0, 166, 81, 0.1)'};
  border-radius: 15px;
  border: 2px solid ${(props) => props.borderColor || 'var(--greenia-color)'};
  padding: 1rem 1.5rem;
  display: flex;
  align-items: center;
  gap: 1rem;
`;

export const OfferStatusIcon = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: ${(props) => props.bg || 'var(--greenia-color)'};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #fff;
  font-size: 1.1rem;
`;

export const BankDetailsCard = styled.div`
  background: #fff;
  border-radius: 20px;
  border: 2px solid #dbdde6;
  padding: 2rem;
`;

export const BankDetailsIcon = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: var(--greenia-color);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 1rem;
  flex-shrink: 0;
  color: #fff;
  font-size: 1.2rem;
`;

export const BankDetailsGrid = styled.div`
  background: #f8f9fa;
  border-radius: 15px;
  padding: 1.25rem;
  border: 1px solid #e9ecef;
`;

export const BankDetailsLabel = styled.p`
  color: #888;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 0.25rem;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
`;

export const BankDetailsValue = styled.p`
  font-weight: 600;
  color: #333;
  margin-bottom: 0;
  word-break: break-all;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
`;

export const SubmitBankButton = styled.button`
  padding: 12px 32px;
  border-radius: 15px;
  border: 2px solid var(--greenia-color);
  background: var(--greenia-color);
  color: #fff;
  font-weight: 600;
  font-size: 1rem;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  transition: all 250ms linear;
  opacity: ${(props) => (props.disabled ? 0.7 : 1)};
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};

  &:hover:not(:disabled) {
    background: transparent;
    color: var(--greenia-color);
  }
`;
